import React, { Component } from 'react'
import { Modal, Button, Image } from 'antd'
import Popconfirm from '../../../../components/Popconfirm/Popconfirm2'
import moment from 'moment'
import { calculationTime, toHourMinuteSecond } from '../../../../util/index'

export default class auditModal extends Component {
  confirmHandle = () => {}

  statusStr = (value) => {
    var str
    switch (value) {
      case 0:
      case 1:
        str = ''
        break
      case 2:
        str = '迟到'
        break
      case 3:
        str = '早退'
        break
      case 4:
        str = '地址异常'
        break
      case 5:
        str = '缺勤'
        break
      case 6:
        str = '休假'
        break
      default:
        str = ''
        break
    }
    return str
  }

  cellState = (dataSource) => {
    if (dataSource.type == 5) {
      return calculationTime(dataSource.startTime, dataSource.endTime)
    }
    return parseInt(dataSource.duration) / 24 / 60 / 60 + '天'
  }

  render() {
    const { dataSource } = this.props
    const {
      type, // 申请类型：1.迟到补卡，2.早退补卡，3.缺勤补卡，4.请假，5.加班，6.地址异常补卡
      startTime, // 开始时间
      endTime, // 结束时间
      content, // 理由
      attachedFileUrl, // 附加图片
      name, // 员工名称
      state, // 打卡状态：1.完成，2.迟到，3.早退，4.地位地址异常，5.缺勤，6.请假
      clockTime, // 打卡时间
      position, // 地址
      normalClockTime, // 补卡时间
    } = dataSource
    return (
      <Modal
        visible
        destroyOnClose
        title={
          type != 4 || type != 5
            ? '补卡申请'
            : type == 4
            ? '休假申请'
            : '加班申请'
        }
        width="400px"
        onCancel={() => this.props.onCancel()}
        footer={[
          <Popconfirm
            key="1"
            title="是否拒绝此员工的申请?"
            okText="是"
            cancelText="否"
            onConfirm={() => this.props.onStatusEvent(dataSource.id, 3)}
          >
            <Button key="1" type="primary" danger>
              拒绝
            </Button>
          </Popconfirm>,
          <Button
            key="2"
            type="primary"
            onClick={() => this.props.onStatusEvent(dataSource.id, 1)}
          >
            通过
          </Button>,
        ]}
      >
        <div className="fake-audit-modal-view">
          <div className="famv-cell-view">
            <span className="fcv-tip-text">员工</span>
            <span className="fcv-tip-detail">{name}</span>
          </div>
          {type == 4 || type == 5 ? (
            <div>
              <div className="famv-cell-view">
                <span className="fcv-tip-text">开始时间</span>
                <span className="fcv-tip-detail">
                  {moment(startTime).format('YYYY.MM.DD HH:mm')}
                </span>
              </div>
              <div className="famv-cell-view">
                <span className="fcv-tip-text">结束时间</span>
                <span className="fcv-tip-detail">
                  {moment(endTime).format('YYYY.MM.DD HH:mm')}
                </span>
              </div>
              <div className="famv-cell-view">
                <span className="fcv-tip-text">
                  {type == 4 ? '休假' : '加班'}时长
                </span>
                <span className="fcv-tip-detail">
                  {this.cellState(dataSource)}
                </span>
              </div>
              <div className="famv-cell-view">
                <span className="fcv-tip-text">
                  {type == 4 ? '休假' : '加班'}理由
                </span>
                <span className="fcv-tip-detail">{content}</span>
              </div>
            </div>
          ) : (
            <div>
              {state < 5 && (
                <div>
                  <div className="famv-cell-view">
                    <span className="fcv-tip-text">打卡时间</span>
                    <span className="fcv-tip-detail">
                      {moment(clockTime).format('YYYY.MM.DD HH:mm')}
                    </span>
                  </div>
                  <div className="famv-cell-view">
                    <span className="fcv-tip-text">打卡地址</span>
                    <span className="fcv-tip-detail">{position}</span>
                  </div>
                </div>
              )}
              <div className="famv-cell-view">
                <span className="fcv-tip-text">异常状态</span>
                <span className="fcv-tip-detail">{this.statusStr(state)}</span>
              </div>
              <div className="famv-cell-view">
                <span className="fcv-tip-text">补卡时间</span>
                <span className="fcv-tip-detail">
                  {moment(normalClockTime).format('YYYY.MM.DD HH:mm')}
                </span>
              </div>
              <div className="famv-cell-view">
                <span className="fcv-tip-text">补卡理由</span>
                <span className="fcv-tip-detail">{content}</span>
              </div>
            </div>
          )}
          <div className="famv-image-cell-view">
            <span className="fcv-tip-text">附加图片</span>
            <div className="fcv-images-view">
              {attachedFileUrl && (
                <div className="image-item">
                  <Image width={60} height={60} src={attachedFileUrl} />
                </div>
              )}

              {/* <div className="image-item">
                <Image width={60} height={60} />
              </div>
              <div className="image-item">
                <Image width={60} height={60} />
              </div> */}
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubAttendanceRecord/component/fakeAttendance/auditModal.js